const initialState = {
  data: [], // Lista de clientes MasNet
  total: 0, // Total de clientes (para paginación)
  eventosTarea: [], // Eventos de tarea por login
};

const clientesMasnet = (state = initialState, action) => {
  switch (action.type) {
    // Carga de clientes MasNet
    case 'GET_CLIENTES_MASNET':
      return {
        ...state,
        data: Array.isArray(action.data) ? action.data : [],
        total: typeof action.total === 'number' ? action.total : 0,
      };

    // Carga de eventos de tarea por login
    case 'SET_EVENTOS_TAREA':
      return {
        ...state,
        eventosTarea: Array.isArray(action.data) ? action.data : [],
      };

    default:
      return state;
  }
};

// ¡Export default para funcionar con combineReducers!
export default clientesMasnet;
